// extracted by mini-css-extract-plugin
export var cardHeader = "_fk-0";
export var reorderHandle = "_fk-3";
export var titleArea = "_fk-1";
export var titleAreaWithHandle = "_fk-2";